import { TextTokenEnum } from '@/Shared/AutoGenerated/LocalizationEnum'

export enum ResponseJsonKeyEnum {
    RedirectUrl = "RedirectUrl",
    Admin_Queue_Pending_PaginatedJobs = "Admin_Queue_Pending_PaginatedJobs",
    Admin_Queue_Pending_Stats = "Admin_Queue_Pending_Stats",
    App_Company_UpdateInfo_CompanyData = "App_Company_UpdateInfo_CompanyData",
    App_Company_DefaultAvailability_CompanyData = "App_Company_DefaultAvailability_CompanyData",
    App_Company_InPersonHostDefinedMeetingLocations = "App_Company_StoreInPersonHostDefinedMeetingLocations",
    App_CompanyUser_UpdateSettings_CompanyUserAggregateData = "App_CompanyUser_UpdateSettings_CompanyUserAggregateData",
    App_Integration_UpdateSettings_IntegrationData = "App_Integration_UpdateSettings_IntegrationData",
    App_User_UpdateProfile_CompanyUserAggregateData = "App_User_UpdateProfile_CompanyUserAggregateData",
    App_CompanyUserInvite_Send_CompanyUserInviteData = "App_CompanyUserInvite_Send_CompanyUserInviteData",
    App_Service_IndexCompanyUsers_CompanyUserAggregatesData = "App_Service_IndexCompanyUsers_CompanyUserAggregatesData",
    App_ServicePrices_Store_ServiceAggregateData = "App_ServicePrices_Store_ServiceAggregateData",
    App_ServicePrices_Update_ServiceAggregateData = "App_ServicePrices_Update_ServiceAggregateData",
    App_Availability_Store_CompanyUserAggregateData = "App_Availability_Store_CompanyUserAggregateData",
    App_Availability_Update_CompanyUserAggregateData = "App_Availability_Update_CompanyUserAggregateData",
    App_Refund_Reservation_MeetingDataData = "App_Refund_Reservation_MeetingDataData",
    App_Refund_Booking_BookingDataData = "App_Refund_Booking_BookingDataData",
    App_Meeting_ToggleNoShow_MeetingDataData = "App_Meeting_ToggleNoShow_MeetingDataData",
    App_CustomFields_Move_ServiceAggregateData = "App_CustomFields_Move_ServiceAggregateData",
    App_CustomFields_Store_ServiceAggregateData = "App_CustomFields_Store_ServiceAggregateData",
    App_CustomFields_Update_ServiceAggregateData = "App_CustomFields_Update_ServiceAggregateData",
    Meeting_Cancel_MeetingDataData = "Meeting_Cancel_MeetingDataData",
    Meeting_Cancel_BookingDataData = "Meeting_Cancel_BookingDataData",
    Rescheduling_IndexAvailableDates_CalendarMonths = "Rescheduling_IndexAvailableDates_CalendarMonths",
    Rescheduling_IndexAvailableDates_AvailabilityResultDates = "Rescheduling_IndexAvailableDates_AvailabilityResultDates",
    Rescheduling_MeetingDataData = "Rescheduling_MeetingDataData",
    App_Availability_AvailabilityData = "App_Availability_AvailabilityData",
    App_Service_Update_ServiceAggregateData = "App_Service_Update_ServiceAggregateData",
    App_Automation_Update_AutomationData = "App_Automation_Update_AutomationData",
    BookingForm_Scheduling_IndexAvailableDates_CalendarMonths = "BookingForm_Scheduling_IndexAvailableDates_CalendarMonths",
    BookingForm_Scheduling_IndexAvailableDates_AvailabilityResultDates = "BookingForm_Scheduling_IndexAvailableDates_AvailabilityResultDates",
    BookingForm_Confirmation_PayPal_OrderId = "BookingForm_Confirmation_PayPal_OrderId",
    Webhook_StripeConnect_JobId = "Webhook_StripeConnect_JobId",
    Webhook_StripeConnect_RequestData = "Webhook_StripeConnect_RequestData",
    Webhook_PayPalMultiParty_JobId = "Webhook_PayPalMultiParty_JobId",
    Webhook_PayPalMultiParty_RequestData = "Webhook_PayPalMultiParty_RequestData",
}

export enum SchedulingStrategyEnum {
    SingleHostSingleAttendee = "SingleHostSingleAttendee",
    SingleHostMultipleAttendee = "SingleHostMultipleAttendee",
}

export const SchedulingStrategyEnumData = {
    [SchedulingStrategyEnum.SingleHostSingleAttendee]: {
        key: SchedulingStrategyEnum.SingleHostSingleAttendee,
        value: "SingleHostSingleAttendee",
        label: "Single Attendee",
        description: 'Only you and a single client. Ex: A discovery call.',
    },
    [SchedulingStrategyEnum.SingleHostMultipleAttendee]: {
        key: SchedulingStrategyEnum.SingleHostMultipleAttendee,
        value: "SingleHostMultipleAttendee",
        label: "Multiple Attendee",
        description: 'You and multiple clients. Ex: A webinar.',
    },
} as const

export const SchedulingStrategyEnumList = [
    {
        key: SchedulingStrategyEnum.SingleHostSingleAttendee,
        value: "SingleHostSingleAttendee",
        label: "Single Attendee",
        description: 'Only you and a single client. Ex: A discovery call.',
    },
    {
        key: SchedulingStrategyEnum.SingleHostMultipleAttendee,
        value: "SingleHostMultipleAttendee",
        label: "Multiple Attendee",
        description: 'You and multiple clients. Ex: A webinar.',
    },
] as const

export type SchedulingStrategyEnumDataEntry = typeof SchedulingStrategyEnumData[SchedulingStrategyEnum]
export type SchedulingStrategyEnumListEntry = typeof SchedulingStrategyEnumList[number]
export type SchedulingStrategyEnumListType = typeof SchedulingStrategyEnumList

export enum CustomFieldTypeEnum {
    Text = "Text",
    RadioSelect = "RadioSelect",
    Number = "Number",
    SingleCheckbox = "SingleCheckbox",
    MultipleCheckbox = "MultipleCheckbox",
}

export enum CustomFieldTextTypeEnum {
    SingleLine = "SingleLine",
    MultiLine = "MultiLine",
}

export enum CustomFieldNumberTypeEnum {
    Integer = "Integer",
    Decimal = "Decimal",
}

export enum CustomFieldSettingsKeysEnum {
    Number_Type = "numberType",
    Number_DecimalPlaces = "numberDecimalPlaces",
    Number_MinValue = "numberMinValue",
    Number_MaxValue = "numberMaxValue",
    Number_StepValue = "numberStepValue",
    Text_Type = "textType",
    Text_PlaceholderText = "textPlaceholderText",
    Text_MinLength = "textMinLength",
    Text_MaxLength = "textMaxLength",
    SingleCheckbox_Label = "singleCheckboxLabel",
    MultipleCheckbox_Options = "multipleCheckboxOptions",
    RadioSelect_Type = "radioSelectType",
    RadioSelect_Options = "radioSelectOptions",
}

export enum CustomFieldRadioSelectTypeEnum {
    Radio = "Radio",
    Select = "Select",
}

export enum AttendanceStateEnum {
    Scheduled = "Scheduled",
    Canceled = "Canceled",
    Completed = "Completed",
    NoShow = "NoShow",
}

export const AttendanceStateEnumData = {
    [AttendanceStateEnum.Scheduled]: {
        key: AttendanceStateEnum.Scheduled,
        value: "Scheduled",
        label: "Scheduled",
    },
    [AttendanceStateEnum.Canceled]: {
        key: AttendanceStateEnum.Canceled,
        value: "Canceled",
        label: "Canceled",
    },
    [AttendanceStateEnum.Completed]: {
        key: AttendanceStateEnum.Completed,
        value: "Completed",
        label: "Completed",
    },
    [AttendanceStateEnum.NoShow]: {
        key: AttendanceStateEnum.NoShow,
        value: "NoShow",
        label: "No Show",
    },
} as const

export const AttendanceStateEnumList = [
    {
        key: AttendanceStateEnum.Scheduled,
        value: "Scheduled",
        label: "Scheduled",
    },
    {
        key: AttendanceStateEnum.Canceled,
        value: "Canceled",
        label: "Canceled",
    },
    {
        key: AttendanceStateEnum.Completed,
        value: "Completed",
        label: "Completed",
    },
    {
        key: AttendanceStateEnum.NoShow,
        value: "NoShow",
        label: "No Show",
    },
] as const

export type AttendanceStateEnumDataEntry = typeof AttendanceStateEnumData[AttendanceStateEnum]
export type AttendanceStateEnumListEntry = typeof AttendanceStateEnumList[number]
export type AttendanceStateEnumListType = typeof AttendanceStateEnumList

export enum RecurrenceFrequencyTypeEnum {
    Single = "Single",
    Weekly = "Weekly",
    BiWeekly = "BiWeekly",
    Monthly = "Monthly",
}

export const RecurrenceFrequencyTypeEnumData = {
    [RecurrenceFrequencyTypeEnum.Single]: {
        key: RecurrenceFrequencyTypeEnum.Single,
        value: "Single",
        label: "Disabled",
        everyLabel: 'Disabled',
    },
    [RecurrenceFrequencyTypeEnum.Weekly]: {
        key: RecurrenceFrequencyTypeEnum.Weekly,
        value: "Weekly",
        label: "Weekly",
        everyLabel: 'Once a week',
    },
    [RecurrenceFrequencyTypeEnum.BiWeekly]: {
        key: RecurrenceFrequencyTypeEnum.BiWeekly,
        value: "BiWeekly",
        label: "Bi-Weekly",
        everyLabel: 'Once every two weeks',
    },
    [RecurrenceFrequencyTypeEnum.Monthly]: {
        key: RecurrenceFrequencyTypeEnum.Monthly,
        value: "Monthly",
        label: "Monthly",
        everyLabel: 'Once a month',
    },
} as const

export const RecurrenceFrequencyTypeEnumList = [
    {
        key: RecurrenceFrequencyTypeEnum.Single,
        value: "Single",
        label: "Disabled",
        everyLabel: 'Disabled',
    },
    {
        key: RecurrenceFrequencyTypeEnum.Weekly,
        value: "Weekly",
        label: "Weekly",
        everyLabel: 'Once a week',
    },
    {
        key: RecurrenceFrequencyTypeEnum.BiWeekly,
        value: "BiWeekly",
        label: "Bi-Weekly",
        everyLabel: 'Once every two weeks',
    },
    {
        key: RecurrenceFrequencyTypeEnum.Monthly,
        value: "Monthly",
        label: "Monthly",
        everyLabel: 'Once a month',
    },
] as const

export type RecurrenceFrequencyTypeEnumDataEntry = typeof RecurrenceFrequencyTypeEnumData[RecurrenceFrequencyTypeEnum]
export type RecurrenceFrequencyTypeEnumListEntry = typeof RecurrenceFrequencyTypeEnumList[number]
export type RecurrenceFrequencyTypeEnumListType = typeof RecurrenceFrequencyTypeEnumList

export enum BookingSchedulingStateEnum {
    Scheduled = "Scheduled",
    Canceled = "Canceled",
    Completed = "Completed",
}

export enum BookingPaymentStateEnum {
    Paid = "Paid",
    Refunded = "Refunded",
}

export enum MeetingSearchFiltersDateTypeEnum {
    Upcoming = "Upcoming",
    Past = "Past",
    Today = "Today",
    Tomorrow = "Tomorrow",
    Next7Days = "Next7Days",
    Next30Days = "Next30Days",
    Custom = "Custom",
    All = "All",
}

export const MeetingSearchFiltersDateTypeEnumData = {
    [MeetingSearchFiltersDateTypeEnum.Upcoming]: {
        key: MeetingSearchFiltersDateTypeEnum.Upcoming,
        value: "Upcoming",
        label: "Upcoming",
    },
    [MeetingSearchFiltersDateTypeEnum.Past]: {
        key: MeetingSearchFiltersDateTypeEnum.Past,
        value: "Past",
        label: "Past",
    },
    [MeetingSearchFiltersDateTypeEnum.Today]: {
        key: MeetingSearchFiltersDateTypeEnum.Today,
        value: "Today",
        label: "Today",
    },
    [MeetingSearchFiltersDateTypeEnum.Tomorrow]: {
        key: MeetingSearchFiltersDateTypeEnum.Tomorrow,
        value: "Tomorrow",
        label: "Tomorrow",
    },
    [MeetingSearchFiltersDateTypeEnum.Next7Days]: {
        key: MeetingSearchFiltersDateTypeEnum.Next7Days,
        value: "Next7Days",
        label: "Next 7 Days",
    },
    [MeetingSearchFiltersDateTypeEnum.Next30Days]: {
        key: MeetingSearchFiltersDateTypeEnum.Next30Days,
        value: "Next30Days",
        label: "Next 30 Days",
    },
    [MeetingSearchFiltersDateTypeEnum.Custom]: {
        key: MeetingSearchFiltersDateTypeEnum.Custom,
        value: "Custom",
        label: "Custom",
    },
    [MeetingSearchFiltersDateTypeEnum.All]: {
        key: MeetingSearchFiltersDateTypeEnum.All,
        value: "All",
        label: "All",
    },
} as const

export const MeetingSearchFiltersDateTypeEnumList = [
    {
        key: MeetingSearchFiltersDateTypeEnum.Upcoming,
        value: "Upcoming",
        label: "Upcoming",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Past,
        value: "Past",
        label: "Past",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Today,
        value: "Today",
        label: "Today",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Tomorrow,
        value: "Tomorrow",
        label: "Tomorrow",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Next7Days,
        value: "Next7Days",
        label: "Next 7 Days",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Next30Days,
        value: "Next30Days",
        label: "Next 30 Days",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.Custom,
        value: "Custom",
        label: "Custom",
    },
    {
        key: MeetingSearchFiltersDateTypeEnum.All,
        value: "All",
        label: "All",
    },
] as const

export type MeetingSearchFiltersDateTypeEnumDataEntry = typeof MeetingSearchFiltersDateTypeEnumData[MeetingSearchFiltersDateTypeEnum]
export type MeetingSearchFiltersDateTypeEnumListEntry = typeof MeetingSearchFiltersDateTypeEnumList[number]
export type MeetingSearchFiltersDateTypeEnumListType = typeof MeetingSearchFiltersDateTypeEnumList

export enum MeetingLocationTypeEnum {
    GoogleMeet = "GoogleMeet",
    Zoom = "Zoom",
    Phone = "Phone",
    InPersonHostDefined = "InPersonHostDefined",
    InPersonAttendeeDefined = "InPersonAttendeeDefined",
}

export const MeetingLocationTypeEnumData = {
    [MeetingLocationTypeEnum.GoogleMeet]: {
        key: MeetingLocationTypeEnum.GoogleMeet,
        value: "GoogleMeet",
        label: "Google Meet",
        localizationTextToken: TextTokenEnum.BookingForm_GoogleMeet,
    },
    [MeetingLocationTypeEnum.Zoom]: {
        key: MeetingLocationTypeEnum.Zoom,
        value: "Zoom",
        label: "Zoom",
        localizationTextToken: TextTokenEnum.BookingForm_Zoom,
    },
    [MeetingLocationTypeEnum.Phone]: {
        key: MeetingLocationTypeEnum.Phone,
        value: "Phone",
        label: "Phone",
        localizationTextToken: TextTokenEnum.BookingForm_Phone,
    },
    [MeetingLocationTypeEnum.InPersonHostDefined]: {
        key: MeetingLocationTypeEnum.InPersonHostDefined,
        value: "InPersonHostDefined",
        label: "In Person (Host location)",
        localizationTextToken: TextTokenEnum.BookingForm_InPersonHostDefined,
    },
    [MeetingLocationTypeEnum.InPersonAttendeeDefined]: {
        key: MeetingLocationTypeEnum.InPersonAttendeeDefined,
        value: "InPersonAttendeeDefined",
        label: "In Person (Attendee location)",
        localizationTextToken: TextTokenEnum.BookingForm_InPersonAttendeeDefined,
    },
} as const

export const MeetingLocationTypeEnumList = [
    {
        key: MeetingLocationTypeEnum.GoogleMeet,
        value: "GoogleMeet",
        label: "Google Meet",
        localizationTextToken: TextTokenEnum.BookingForm_GoogleMeet,
    },
    {
        key: MeetingLocationTypeEnum.Zoom,
        value: "Zoom",
        label: "Zoom",
        localizationTextToken: TextTokenEnum.BookingForm_Zoom,
    },
    {
        key: MeetingLocationTypeEnum.Phone,
        value: "Phone",
        label: "Phone",
        localizationTextToken: TextTokenEnum.BookingForm_Phone,
    },
    {
        key: MeetingLocationTypeEnum.InPersonHostDefined,
        value: "InPersonHostDefined",
        label: "In Person (Host location)",
        localizationTextToken: TextTokenEnum.BookingForm_InPersonHostDefined,
    },
    {
        key: MeetingLocationTypeEnum.InPersonAttendeeDefined,
        value: "InPersonAttendeeDefined",
        label: "In Person (Attendee location)",
        localizationTextToken: TextTokenEnum.BookingForm_InPersonAttendeeDefined,
    },
] as const

export type MeetingLocationTypeEnumDataEntry = typeof MeetingLocationTypeEnumData[MeetingLocationTypeEnum]
export type MeetingLocationTypeEnumListEntry = typeof MeetingLocationTypeEnumList[number]
export type MeetingLocationTypeEnumListType = typeof MeetingLocationTypeEnumList

export enum MeetingExternalEventSyncStateEnum {
    Synced = "Synced",
    IntegrationNotFound = "Integration Not Found",
    IntegrationRevoked = "Integration Revoked",
    IntegrationInvalid = "Invalid Integration",
    IntegrationProviderMismatch = "Integration Provider Mismatch",
    UserDeleted = "User Deleted",
    Error = "Error",
}

export enum MeetingStateEnum {
    Scheduled = "Scheduled",
    Canceled = "Canceled",
    Completed = "Completed",
    NoShow = "NoShow",
}

export const MeetingStateEnumData = {
    [MeetingStateEnum.Scheduled]: {
        key: MeetingStateEnum.Scheduled,
        value: "Scheduled",
        label: "Scheduled",
    },
    [MeetingStateEnum.Canceled]: {
        key: MeetingStateEnum.Canceled,
        value: "Canceled",
        label: "Canceled",
    },
    [MeetingStateEnum.Completed]: {
        key: MeetingStateEnum.Completed,
        value: "Completed",
        label: "Completed",
    },
    [MeetingStateEnum.NoShow]: {
        key: MeetingStateEnum.NoShow,
        value: "NoShow",
        label: "No Show",
    },
} as const

export const MeetingStateEnumList = [
    {
        key: MeetingStateEnum.Scheduled,
        value: "Scheduled",
        label: "Scheduled",
    },
    {
        key: MeetingStateEnum.Canceled,
        value: "Canceled",
        label: "Canceled",
    },
    {
        key: MeetingStateEnum.Completed,
        value: "Completed",
        label: "Completed",
    },
    {
        key: MeetingStateEnum.NoShow,
        value: "NoShow",
        label: "No Show",
    },
] as const

export type MeetingStateEnumDataEntry = typeof MeetingStateEnumData[MeetingStateEnum]
export type MeetingStateEnumListEntry = typeof MeetingStateEnumList[number]
export type MeetingStateEnumListType = typeof MeetingStateEnumList

export enum IntegrationProviderEnum {
    Void = "",
    GoogleCalendar = "GoogleCalendar",
    OutlookCalendar = "OutlookCalendar",
    GoogleMeet = "GoogleMeet",
    Zoom = "Zoom",
    StripeConnect = "StripeConnect",
    PayPalMultiParty = "PayPalMultiParty",
}

export const IntegrationProviderEnumData = {
    [IntegrationProviderEnum.Void]: {
        key: IntegrationProviderEnum.Void,
        value: "",
        label: "[DISABLED]",
        isHighlightedDuringOnboarding: false,
    },
    [IntegrationProviderEnum.GoogleCalendar]: {
        key: IntegrationProviderEnum.GoogleCalendar,
        value: "GoogleCalendar",
        label: "Google Calendar",
        isHighlightedDuringOnboarding: true,
    },
    [IntegrationProviderEnum.OutlookCalendar]: {
        key: IntegrationProviderEnum.OutlookCalendar,
        value: "OutlookCalendar",
        label: "Outlook Calendar",
        isHighlightedDuringOnboarding: false,
    },
    [IntegrationProviderEnum.GoogleMeet]: {
        key: IntegrationProviderEnum.GoogleMeet,
        value: "GoogleMeet",
        label: "Google Meet",
        isHighlightedDuringOnboarding: false,
    },
    [IntegrationProviderEnum.Zoom]: {
        key: IntegrationProviderEnum.Zoom,
        value: "Zoom",
        label: "Zoom",
        isHighlightedDuringOnboarding: false,
    },
    [IntegrationProviderEnum.StripeConnect]: {
        key: IntegrationProviderEnum.StripeConnect,
        value: "StripeConnect",
        label: "Stripe",
        isHighlightedDuringOnboarding: false,
    },
    [IntegrationProviderEnum.PayPalMultiParty]: {
        key: IntegrationProviderEnum.PayPalMultiParty,
        value: "PayPalMultiParty",
        label: "PayPal",
        isHighlightedDuringOnboarding: false,
    },
} as const

export const IntegrationProviderEnumList = [
    {
        key: IntegrationProviderEnum.Void,
        value: "",
        label: "[DISABLED]",
        isHighlightedDuringOnboarding: false,
    },
    {
        key: IntegrationProviderEnum.GoogleCalendar,
        value: "GoogleCalendar",
        label: "Google Calendar",
        isHighlightedDuringOnboarding: true,
    },
    {
        key: IntegrationProviderEnum.OutlookCalendar,
        value: "OutlookCalendar",
        label: "Outlook Calendar",
        isHighlightedDuringOnboarding: false,
    },
    {
        key: IntegrationProviderEnum.GoogleMeet,
        value: "GoogleMeet",
        label: "Google Meet",
        isHighlightedDuringOnboarding: false,
    },
    {
        key: IntegrationProviderEnum.Zoom,
        value: "Zoom",
        label: "Zoom",
        isHighlightedDuringOnboarding: false,
    },
    {
        key: IntegrationProviderEnum.StripeConnect,
        value: "StripeConnect",
        label: "Stripe",
        isHighlightedDuringOnboarding: false,
    },
    {
        key: IntegrationProviderEnum.PayPalMultiParty,
        value: "PayPalMultiParty",
        label: "PayPal",
        isHighlightedDuringOnboarding: false,
    },
] as const

export type IntegrationProviderEnumDataEntry = typeof IntegrationProviderEnumData[IntegrationProviderEnum]
export type IntegrationProviderEnumListEntry = typeof IntegrationProviderEnumList[number]
export type IntegrationProviderEnumListType = typeof IntegrationProviderEnumList

export enum IntegrationStateEnum {
    Active = "Active",
    Inactive = "Inactive",
    Revoked = "Revoked",
}

export enum UserRoleEnum {
    Owner = "Owner",
    Admin = "Admin",
    Member = "Member",
}

export enum UserSocialAuthenticationActionEnum {
    Login = "Login",
    Register = "Register",
}

export enum PlanTypeEnum {
    Free = "Free",
    Paid = "Paid",
}

export enum PlanPeriodEnum {
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export enum PlanFeaturesAccessEnum {
    PaymentsStripe = "PaymentsStripe",
    AppointnemtRemindersEmail = "AppointnemtRemindersEmail",
    BookingFormTheme = "BookingFormTheme",
    CustomFields = "CustomFields",
    ExternalCalendarCheck = "ExternalCalendarCheck",
    ExternalCalendarSync = "ExternalCalendarSync",
    SingleHostMultipleAttendee = "SingleHostMultipleAttendee",
    RecurringMeeting = "RecurringMeeting",
}

export enum SubscriptionStatusEnum {
    Free = "Free",
    Active = "Active",
    Canceled = "Canceled",
    GracePeriod = "Grace Period",
}

export enum PlanFeaturesQuantityEnum {
    CompanyUsers = "CompanyUsers",
    Services = "Services",
}

export enum EditServiceOriginEnum {
    ProfilePage = "ProfilePage",
    CompanyUserPage = "CompanyUserPage",
}

export enum DayOfWeekEnum {
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday",
}

export enum AutomationActionTypeEnum {
    SendHostMeetingReminderEmail = "SendHostMeetingReminderEmail",
    SendAttendeeMeetingReminderEmail = "SendAttendeeMeetingReminderEmail",
}

export const AutomationActionTypeEnumData = {
    [AutomationActionTypeEnum.SendHostMeetingReminderEmail]: {
        key: AutomationActionTypeEnum.SendHostMeetingReminderEmail,
        value: "SendHostMeetingReminderEmail",
        label: "Send email reminder to host",
    },
    [AutomationActionTypeEnum.SendAttendeeMeetingReminderEmail]: {
        key: AutomationActionTypeEnum.SendAttendeeMeetingReminderEmail,
        value: "SendAttendeeMeetingReminderEmail",
        label: "Send email reminder to attendee",
    },
} as const

export const AutomationActionTypeEnumList = [
    {
        key: AutomationActionTypeEnum.SendHostMeetingReminderEmail,
        value: "SendHostMeetingReminderEmail",
        label: "Send email reminder to host",
    },
    {
        key: AutomationActionTypeEnum.SendAttendeeMeetingReminderEmail,
        value: "SendAttendeeMeetingReminderEmail",
        label: "Send email reminder to attendee",
    },
] as const

export type AutomationActionTypeEnumDataEntry = typeof AutomationActionTypeEnumData[AutomationActionTypeEnum]
export type AutomationActionTypeEnumListEntry = typeof AutomationActionTypeEnumList[number]
export type AutomationActionTypeEnumListType = typeof AutomationActionTypeEnumList

export enum AutomationTriggerTypeEnum {
    XMinutesBeforeMeetingStarts = "XMinutesBeforeMeetingStarts",
}

export const AutomationTriggerTypeEnumData = {
    [AutomationTriggerTypeEnum.XMinutesBeforeMeetingStarts]: {
        key: AutomationTriggerTypeEnum.XMinutesBeforeMeetingStarts,
        value: "XMinutesBeforeMeetingStarts",
        label: "X minutes before starting a meeting",
    },
} as const

export const AutomationTriggerTypeEnumList = [
    {
        key: AutomationTriggerTypeEnum.XMinutesBeforeMeetingStarts,
        value: "XMinutesBeforeMeetingStarts",
        label: "X minutes before starting a meeting",
    },
] as const

export type AutomationTriggerTypeEnumDataEntry = typeof AutomationTriggerTypeEnumData[AutomationTriggerTypeEnum]
export type AutomationTriggerTypeEnumListEntry = typeof AutomationTriggerTypeEnumList[number]
export type AutomationTriggerTypeEnumListType = typeof AutomationTriggerTypeEnumList

export enum AutomationStateEnum {
    Enabled = "Enabled",
    Disabled = "Disabled",
}

export const AutomationStateEnumData = {
    [AutomationStateEnum.Enabled]: {
        key: AutomationStateEnum.Enabled,
        value: "Enabled",
        label: "Enabled",
    },
    [AutomationStateEnum.Disabled]: {
        key: AutomationStateEnum.Disabled,
        value: "Disabled",
        label: "Disabled",
    },
} as const

export const AutomationStateEnumList = [
    {
        key: AutomationStateEnum.Enabled,
        value: "Enabled",
        label: "Enabled",
    },
    {
        key: AutomationStateEnum.Disabled,
        value: "Disabled",
        label: "Disabled",
    },
] as const

export type AutomationStateEnumDataEntry = typeof AutomationStateEnumData[AutomationStateEnum]
export type AutomationStateEnumListEntry = typeof AutomationStateEnumList[number]
export type AutomationStateEnumListType = typeof AutomationStateEnumList

export enum PaymentMethodTypeEnum {
    Card = "Card",
    PayPal = "PayPal",
}

export enum PaymentMethodModeEnum {
    SavedPaymentMethod = "SavedPaymentMethod",
    NewPaymentMethod = "NewPaymentMethod",
}

export enum PreDefinedAvailabilityTypeEnum {
    Weekdays9to5 = "Weekdays9to5",
    WeekdayMornings = "WeekdayMornings",
    WeekdayAfternoons = "WeekdayAfternoons",
    CustomHours = "CustomHours",
}

export enum BookingReasonEnum {
    DiscoveryCalls = "DiscoveryCalls",
    CoachingSessions = "CoachingSessions",
    ConsultingSessions = "ConsultingSessions",
    StrategyCalls = "StrategyCalls",
    OfficeHours = "OfficeHours",
    PaidAppointments = "PaidAppointments",
}

export const BookingReasonEnumData = {
    [BookingReasonEnum.DiscoveryCalls]: {
        key: BookingReasonEnum.DiscoveryCalls,
        value: "DiscoveryCalls",
        label: "Discovery Calls",
        description: 'Intro calls to qualify leads and understand client needs.',
    },
    [BookingReasonEnum.CoachingSessions]: {
        key: BookingReasonEnum.CoachingSessions,
        value: "CoachingSessions",
        label: "Coaching Sessions",
        description: 'Recurring sessions focused on accountability and progress.',
    },
    [BookingReasonEnum.ConsultingSessions]: {
        key: BookingReasonEnum.ConsultingSessions,
        value: "ConsultingSessions",
        label: "Consulting Sessions",
        description: 'Expert advisory calls to solve specific business problems.',
    },
    [BookingReasonEnum.StrategyCalls]: {
        key: BookingReasonEnum.StrategyCalls,
        value: "StrategyCalls",
        label: "Strategy Calls",
        description: 'Working sessions to plan priorities and next steps.',
    },
    [BookingReasonEnum.OfficeHours]: {
        key: BookingReasonEnum.OfficeHours,
        value: "OfficeHours",
        label: "Office Hours",
        description: 'Open time blocks for support, questions, and quick guidance.',
    },
    [BookingReasonEnum.PaidAppointments]: {
        key: BookingReasonEnum.PaidAppointments,
        value: "PaidAppointments",
        label: "Paid Appointments",
        description: 'Premium sessions booked as a paid service.',
    },
} as const

export const BookingReasonEnumList = [
    {
        key: BookingReasonEnum.DiscoveryCalls,
        value: "DiscoveryCalls",
        label: "Discovery Calls",
        description: 'Intro calls to qualify leads and understand client needs.',
    },
    {
        key: BookingReasonEnum.CoachingSessions,
        value: "CoachingSessions",
        label: "Coaching Sessions",
        description: 'Recurring sessions focused on accountability and progress.',
    },
    {
        key: BookingReasonEnum.ConsultingSessions,
        value: "ConsultingSessions",
        label: "Consulting Sessions",
        description: 'Expert advisory calls to solve specific business problems.',
    },
    {
        key: BookingReasonEnum.StrategyCalls,
        value: "StrategyCalls",
        label: "Strategy Calls",
        description: 'Working sessions to plan priorities and next steps.',
    },
    {
        key: BookingReasonEnum.OfficeHours,
        value: "OfficeHours",
        label: "Office Hours",
        description: 'Open time blocks for support, questions, and quick guidance.',
    },
    {
        key: BookingReasonEnum.PaidAppointments,
        value: "PaidAppointments",
        label: "Paid Appointments",
        description: 'Premium sessions booked as a paid service.',
    },
] as const

export type BookingReasonEnumDataEntry = typeof BookingReasonEnumData[BookingReasonEnum]
export type BookingReasonEnumListEntry = typeof BookingReasonEnumList[number]
export type BookingReasonEnumListType = typeof BookingReasonEnumList

export enum CoverImagePositionEnum {
    Top = "Top",
    Center = "Center",
    Bottom = "Bottom",
}

export const CoverImagePositionEnumData = {
    [CoverImagePositionEnum.Top]: {
        key: CoverImagePositionEnum.Top,
        value: "Top",
        label: "Top",
    },
    [CoverImagePositionEnum.Center]: {
        key: CoverImagePositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    [CoverImagePositionEnum.Bottom]: {
        key: CoverImagePositionEnum.Bottom,
        value: "Bottom",
        label: "Bottom",
    },
} as const

export const CoverImagePositionEnumList = [
    {
        key: CoverImagePositionEnum.Top,
        value: "Top",
        label: "Top",
    },
    {
        key: CoverImagePositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    {
        key: CoverImagePositionEnum.Bottom,
        value: "Bottom",
        label: "Bottom",
    },
] as const

export type CoverImagePositionEnumDataEntry = typeof CoverImagePositionEnumData[CoverImagePositionEnum]
export type CoverImagePositionEnumListEntry = typeof CoverImagePositionEnumList[number]
export type CoverImagePositionEnumListType = typeof CoverImagePositionEnumList

export enum CookieConsentScriptProviderEnum {
    PostHog = "PostHog",
    GoogleAnalytics = "GoogleAnalytics",
    MicrosoftClarity = "MicrosoftClarity",
}

export enum CookieConsentAuthEntityTypeEnum {
    User = "User",
    Customer = "Customer",
}

export enum AnalyticsSourceTypeEnum {
    App = "App",
    BookingForm = "BookingForm",
    Worker = "Worker",
    Webhook = "Webhook",
}

export enum AnalyticsEventNameEnum {
    AccountCreated = "AccountCreated",
    EmailVerified = "EmailVerified",
    FirstLogin = "FirstLogin",
    OnboardingStepViewed = "OnboardingStepViewed",
    OnboardingStepCompleted = "OnboardingStepCompleted",
    OnboardingCompleted = "OnboardingCompleted",
    AvailabilityConfigured = "AvailabilityConfigured",
    IntegrationConnected = "IntegrationConnected",
    IntegrationDeleted = "IntegrationDeleted",
    ServiceCreated = "ServiceCreated",
    ServiceConfiguredBeyondDefault = "ServiceConfiguredBeyondDefault",
    AutomationEnabled = "AutomationEnabled",
    AutomationDisabled = "AutomationDisabled",
    BookingLinkCopied = "BookingLinkCopied",
    EmbedCodeCopied = "EmbedCodeCopied",
    BookingFlowStarted = "BookingFlowStarted",
    BookingFlowCompleted = "BookingFlowCompleted",
    MeetingCompleted = "MeetingCompleted",
    SubscriptionCheckoutStarted = "SubscriptionCheckoutStarted",
    SubscriptionActivated = "SubscriptionActivated",
    SubscriptionGracePeriodStarted = "SubscriptionGracePeriodStarted",
    SubscriptionCanceled = "SubscriptionCanceled",
}

export enum AnalyticsEventSurfaceEnum {
    Onboarding = "Onboarding",
    Auth_Email = "Auth_Email",
    Auth_OAuth = "Auth_OAuth",
    Billing = "Billing",
    Webhook = "Webhook",
    Automation_IndexPage = "Automation_IndexPage",
    Availability_EditPage = "Availability_EditPage",
    Service_IndexPage = "Service_IndexPage",
    Service_EditPage = "Service_EditPage",
    Integration_IndexPage = "Integration_IndexPage",
    BookingForm_BookingFlow = "BookingForm_BookingFlow",
    Meeting_CompletionJob = "Meeting_CompletionJob",
    Share_BookingPageLink_DashboardPage = "Share_BookingPageLink_DashboardPage",
    Share_BookingPageLink_IndexServicePage = "Share_BookingPageLink_IndexServicePage",
    Share_ServicePageLink_ServiceCard = "Share_ServicePageLink_ServiceCard",
    Copy_EmbedButton_Designer = "Copy_EmbedButton_Designer",
}

export enum MimeTypeEnum {
    ImagePng = "image/png",
    ImageJpg = "image/jpg",
    ImageJpeg = "image/jpeg",
    ImageWebp = "image/webp",
    TextCsv = "text/csv",
}

export enum FileExtensionEnum {
    Png = "png",
    Jpg = "jpg",
    Jpeg = "jpeg",
    Webp = "webp",
    Csv = "csv",
}

export enum ImageHorizontalPositionEnum {
    Start = "Start",
    Center = "Center",
    End = "End",
}

export const ImageHorizontalPositionEnumData = {
    [ImageHorizontalPositionEnum.Start]: {
        key: ImageHorizontalPositionEnum.Start,
        value: "Start",
        label: "Start",
    },
    [ImageHorizontalPositionEnum.Center]: {
        key: ImageHorizontalPositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    [ImageHorizontalPositionEnum.End]: {
        key: ImageHorizontalPositionEnum.End,
        value: "End",
        label: "End",
    },
} as const

export const ImageHorizontalPositionEnumList = [
    {
        key: ImageHorizontalPositionEnum.Start,
        value: "Start",
        label: "Start",
    },
    {
        key: ImageHorizontalPositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    {
        key: ImageHorizontalPositionEnum.End,
        value: "End",
        label: "End",
    },
] as const

export type ImageHorizontalPositionEnumDataEntry = typeof ImageHorizontalPositionEnumData[ImageHorizontalPositionEnum]
export type ImageHorizontalPositionEnumListEntry = typeof ImageHorizontalPositionEnumList[number]
export type ImageHorizontalPositionEnumListType = typeof ImageHorizontalPositionEnumList

export enum ImageVerticalPositionEnum {
    Top = "Top",
    Center = "Center",
    Bottom = "Bottom",
}

export const ImageVerticalPositionEnumData = {
    [ImageVerticalPositionEnum.Top]: {
        key: ImageVerticalPositionEnum.Top,
        value: "Top",
        label: "Top",
    },
    [ImageVerticalPositionEnum.Center]: {
        key: ImageVerticalPositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    [ImageVerticalPositionEnum.Bottom]: {
        key: ImageVerticalPositionEnum.Bottom,
        value: "Bottom",
        label: "Bottom",
    },
} as const

export const ImageVerticalPositionEnumList = [
    {
        key: ImageVerticalPositionEnum.Top,
        value: "Top",
        label: "Top",
    },
    {
        key: ImageVerticalPositionEnum.Center,
        value: "Center",
        label: "Center",
    },
    {
        key: ImageVerticalPositionEnum.Bottom,
        value: "Bottom",
        label: "Bottom",
    },
] as const

export type ImageVerticalPositionEnumDataEntry = typeof ImageVerticalPositionEnumData[ImageVerticalPositionEnum]
export type ImageVerticalPositionEnumListEntry = typeof ImageVerticalPositionEnumList[number]
export type ImageVerticalPositionEnumListType = typeof ImageVerticalPositionEnumList

export enum TimeAmountTypeEnum {
    Seconds = "Seconds",
    Minutes = "Minutes",
    Hours = "Hours",
    Days = "Days",
}

export enum CMSSubcategorySlugEnum {
    HelpCenter_Subcategory1 = "subcategory-1",
    HelpCenter_Guides = "guides",
    HelpCenter_GettingStarted = "getting-started",
    HelpCenter_Advanced = "advanced",
}

export enum CMSCategorySlugEnum {
    HelpCenter_Category1 = "category-1",
    HelpCenter_Category2 = "category-2",
    Blog_Scheduling = "scheduling",
}

export enum CMSArticleSlugEnum {
    HelpCenter_Article1 = "article-1",
    HelpCenter_Article2 = "article-2",
    Blog_WhatIsCalendly = "what-is-calendly",
    Blog_RecurringMeetingOutlook = "recurring-meeting-outlook",
    Blog_WhyRecurringMeetingsAreTheSecretWeaponYoureMissing = "why-recurring-meetings-are-the-secret-weapon-youre-missing",
    Blog_MostProductiveTimeToScheduleMeeting = "most-productive-time-to-schedule-meeting",
    Blog_BestMeetingReminderSystemChurch = "best-meeting-reminder-system-church",
    Blog_TaskManagementSystemCharteredAccountants = "task-management-system-chartered-accountants",
    Blog_BookingSystemBands = "booking-system-bands",
    Blog_HowToWriteMeetingAgenda = "how-to-write-meeting-agenda",
    Blog_HowEntrepreneursStayProactiveUsingCalendar = "how-entrepreneurs-stay-proactive-using-calendar",
    Blog_HowToUseRobertsRulesOrderMeetingEfficiency = "how-to-use-roberts-rules-order-meeting-efficiency",
    Blog_HowToOrganizeRecurringAppointmentsSmallBusiness = "how-to-organize-recurring-appointments-small-business",
    Blog_BestPlasmaAppointmentSchedulingApps = "best-plasma-appointment-scheduling-apps",
    Blog_HowToSetUpSmallSalonOnlineBooking = "how-to-set-up-small-salon-online-booking",
    Blog_BestWaysToStartAMeeting = "best-ways-to-start-a-meeting",
    Blog_BestSchedulingAppsForPersonalTrainers = "best-scheduling-apps-for-personal-trainers",
    Blog_AppointmentReminderSoftwareForDogTraining = "appointment-reminder-software-for-dog-training",
    Blog_HowToOrganizeAMeeting = "how-to-organize-a-meeting",
    Blog_HowToCreateAnOrganizationWideCalendar = "how-to-create-an-organization-wide-calendar",
    Blog_HowToManageTooManyMeetings = "how-to-manage-too-many-meetings",
    Blog_BestBookingSystemsForPlumbers = "best-booking-systems-for-plumbers",
    Blog_HowToPlanYourDayAsACarSalesman = "how-to-plan-your-day-as-a-car-salesman",
    Blog_BookingSystemForEstheticians = "booking-system-for-estheticians",
    Blog_BestSchedulingAppsMakeUpArtists = "best-scheduling-apps-make-up-artists",
    Blog_MiniPhotoSessionBookingApp = "mini-photo-session-booking-app",
    Blog_AutoShopAppointmentSchedulingSoftware = "auto-shop-appointment-scheduling-software",
    Blog_HowYouUseDigitalCalendarEffectivelyCompleteGuide = "how-you-use-digital-calendar-effectively-complete-guide",
    Blog_HowOftenShouldStaffMeetingsHeld = "how-often-should-staff-meetings-held",
    Blog_MusicLessonBookingSystem = "music-lesson-booking-system",
    Blog_AdvantageSchedulingToolsOverPaperCalendars = "advantage-scheduling-tools-over-paper-calendars",
    Blog_HowLongShouldMeetingLast = "how-long-should-meeting-last",
    Blog_WhatThe402040RuleMeetings = "what-the-40-20-40-rule-meetings",
    Blog_NewFeatureCustomBookingFormThemes = "new-feature-custom-booking-form-themes",
    Blog_TopFeaturesBestOnlineSchedulingSoftware = "top-features-best-online-scheduling-software",
    Blog_MakeMoreSalesWithAppointmentSoftwareForSmallBusiness = "make-more-sales-with-appointment-software-for-small-business",
    Blog_TopElementorBusinessConsultingWordpressThemes = "top-elementor-business-consulting-wordpress-themes",
    Blog_TopConsultingBusinessNameGenerators = "top-consulting-business-name-generators",
    Blog_Top10BenefitsAppointmentSchedulingSoftware = "top-10-benefits-appointment-scheduling-software",
    Blog_StreamlineYourScheduleWithAnEasyAppointmentBookingApp = "streamline-your-schedule-with-an-easy-appointment-booking-app",
    Blog_AvoidingCommonAppointmentSchedulingMistakes = "avoiding-common-appointment-scheduling-mistakes",
    Blog_EffectiveTimingAndSchedulingTipsForClientAppointments = "effective-timing-and-scheduling-tips-for-client-appointments",
}

export enum CurrencyEnum {
    USD = "USD",
    CAD = "CAD",
    GBP = "GBP",
    EUR = "EUR",
    AUD = "AUD",
    BRL = "BRL",
}

export const CurrencyEnumData = {
    [CurrencyEnum.USD]: {
        key: CurrencyEnum.USD,
        value: "USD",
        label: "USD",
        symbol: '$',
    },
    [CurrencyEnum.CAD]: {
        key: CurrencyEnum.CAD,
        value: "CAD",
        label: "CAD",
        symbol: 'CA$',
    },
    [CurrencyEnum.GBP]: {
        key: CurrencyEnum.GBP,
        value: "GBP",
        label: "GBP",
        symbol: '£',
    },
    [CurrencyEnum.EUR]: {
        key: CurrencyEnum.EUR,
        value: "EUR",
        label: "EUR",
        symbol: '€',
    },
    [CurrencyEnum.AUD]: {
        key: CurrencyEnum.AUD,
        value: "AUD",
        label: "AUD",
        symbol: 'AU$',
    },
    [CurrencyEnum.BRL]: {
        key: CurrencyEnum.BRL,
        value: "BRL",
        label: "BRL",
        symbol: 'R$',
    },
} as const

export const CurrencyEnumList = [
    {
        key: CurrencyEnum.USD,
        value: "USD",
        label: "USD",
        symbol: '$',
    },
    {
        key: CurrencyEnum.CAD,
        value: "CAD",
        label: "CAD",
        symbol: 'CA$',
    },
    {
        key: CurrencyEnum.GBP,
        value: "GBP",
        label: "GBP",
        symbol: '£',
    },
    {
        key: CurrencyEnum.EUR,
        value: "EUR",
        label: "EUR",
        symbol: '€',
    },
    {
        key: CurrencyEnum.AUD,
        value: "AUD",
        label: "AUD",
        symbol: 'AU$',
    },
    {
        key: CurrencyEnum.BRL,
        value: "BRL",
        label: "BRL",
        symbol: 'R$',
    },
] as const

export type CurrencyEnumDataEntry = typeof CurrencyEnumData[CurrencyEnum]
export type CurrencyEnumListEntry = typeof CurrencyEnumList[number]
export type CurrencyEnumListType = typeof CurrencyEnumList

export enum FlashStatusTypeEnum {
    Success = "Success",
    Error = "Error",
}

export enum MergeTagGroupEnum {
    SampleGroup = "SampleGroup",
}

export const MergeTagGroupEnumData = {
    [MergeTagGroupEnum.SampleGroup]: {
        key: MergeTagGroupEnum.SampleGroup,
        value: "SampleGroup",
        label: "Sample Group",
    },
} as const

export const MergeTagGroupEnumList = [
    {
        key: MergeTagGroupEnum.SampleGroup,
        value: "SampleGroup",
        label: "Sample Group",
    },
] as const

export type MergeTagGroupEnumDataEntry = typeof MergeTagGroupEnumData[MergeTagGroupEnum]
export type MergeTagGroupEnumListEntry = typeof MergeTagGroupEnumList[number]
export type MergeTagGroupEnumListType = typeof MergeTagGroupEnumList

export enum MergeTagEnum {
    SampleTag = "SampleTag",
}

export const MergeTagEnumData = {
    [MergeTagEnum.SampleTag]: {
        key: MergeTagEnum.SampleTag,
        value: "SampleTag",
        label: "Sample Tag",
        groupKey: MergeTagGroupEnum.SampleGroup,
        rawTag: 'sample_group.sample_tag',
        wrappedTag: '{{sample_group.sample_tag}}',
    },
} as const

export const MergeTagEnumList = [
    {
        key: MergeTagEnum.SampleTag,
        value: "SampleTag",
        label: "Sample Tag",
        groupKey: MergeTagGroupEnum.SampleGroup,
        rawTag: 'sample_group.sample_tag',
        wrappedTag: '{{sample_group.sample_tag}}',
    },
] as const

export type MergeTagEnumDataEntry = typeof MergeTagEnumData[MergeTagEnum]
export type MergeTagEnumListEntry = typeof MergeTagEnumList[number]
export type MergeTagEnumListType = typeof MergeTagEnumList

export interface BEShowCompanyUserAcceptInvitePagePropKeys {
    appSharedDataData: any,
    companyUserInviteData: any,
    companyData: any,
    destinationUrl: any,
}

export interface BEIndexMeetingsPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedMeetingsData: any,
    servicesData: any,
    companyUserAggregatesData: any,
    meetingSearchFilters: any,
}

export interface BEIndexRecurringMeetingPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedBookingsData: any,
    recurringMeetingSearchFilters: any,
}

export interface BEIndexIntegrationPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    companyIntegrationsData: any,
    companyUserIntegrationsData: any,
    companyIntegrationProviders: any,
    companyUserIntegrationProviders: any,
    preSelectedProvider: any,
    hasPayPalFeatureFlag: any,
}

export interface BEShowRegisterPagePropKeys {
    appSharedDataData: any,
    googleSocialLoginEnabled: any,
    microsoftSocialLoginEnabled: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BECreateNewPasswordPagePropKeys {
    appSharedDataData: any,
    token: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BEShowPasswordResetPagePropKeys {
    appSharedDataData: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BEShowUserLoginPagePropKeys {
    appSharedDataData: any,
    googleSocialLoginEnabled: any,
    microsoftSocialLoginEnabled: any,
    destinationUrl: any,
}

export interface BEShowCompanySelectionPagePropKeys {
    appSharedDataData: any,
    companiesData: any,
    destinationUrl: any,
}

export interface BEShowEmailVerificationPagePropKeys {
    appSharedDataData: any,
    gmailSniperLink: any,
}

export interface BEShowMyProfilePagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    companyUserAggregateData: any,
    servicesData: any,
    availabilitiesData: any,
}

export interface BEEditPlanPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    plansData: any,
    changePlan: any,
    type: any,
    quantity: any,
}

export interface BEStartPaddleCheckoutPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    planData: any,
    paddleCustomerId: any,
    paddleEnvironment: any,
    paddleClientToken: any,
}

export interface BEIndexPlanPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    plansData: any,
    type: any,
    quantity: any,
    changePlan: any,
}

export interface BEEditCompanyUserPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    companyUserAggregateData: any,
    servicesData: any,
    availabilitiesData: any,
}

export interface BEEditAvailabilityPagePropKeys {
    pageMeta: PageMeta,
    hasAvailabilityNaturalLanguageParsingFeatureFlag: any,
    appSharedDataData: any,
    availabilityData: any,
}

export interface BEIndexAvailabilityPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    availabilitiesData: any,
}

export interface BEIndexAutomationPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataRawData: any,
    automationsPaginatedData: any,
    searchFilters: any,
}

export interface BEEditAutomationPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataRawData: any,
    automationRawData: any,
    servicesRawData: any,
}

export interface BEEditServicePagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    serviceAggregateData: any,
    meetingLocations: any,
    paymentIntegrationsData: any,
    companyUserAggregatesData: any,
    availabilitiesData: any,
}

export interface BEIndexServicePagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    servicesData: any,
    meetingLocations: any,
}

export interface BEIndexCustomerPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedCompanyCustomerAggregates: any,
}

export interface BEEditCompanyPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    planData: any,
    subscriptionData: any,
    companyData: any,
    companyUserAggregatesData: any,
    companyUserInvitesData: any,
}

export interface BEShowDashboardPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    meetingStats: any,
    servicesData: any,
}

export interface BEShowBookingFormSuccessStepPagePropKeys {
    bookingFormSharedDataData: any,
    companyData: any,
    firstMeetingDataData: any,
    scheduledRecurringDatesInSelectedTimezoneData: any,
}

export interface BEShowBookingFormDateStepPagePropKeys {
    bookingFormSharedDataData: any,
    draftMeetingData: any,
    companyData: any,
    serviceAggregateData: any,
    companyUserAggregateData: any,
}

export interface BEShowBookingFormConfirmationStepPagePropKeys {
    bookingFormSharedDataData: any,
    draftMeetingData: any,
    companyUserAggregateData: any,
    serviceAggregateData: any,
    companyData: any,
    customerPaymentMethodsData: any,
    stripePublicKey: any,
    payPalClientId: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
    hasSavePaymentMethodFeatureFlag: any,
    previewMeetingDatesData: any,
}

export interface BEShowBookingFormCompanyUserStepPagePropKeys {
    bookingFormSharedDataData: any,
    draftMeetingId: any,
    serviceAggregateData: any,
    companyUserAggregatesData: any,
    companyData: any,
}

export interface BEShowBookingFormServiceStepPagePropKeys {
    bookingFormSharedDataData: any,
    servicesData: any,
    companyData: any,
}

export interface BEIndexUsersPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedCompanyUsersData: any,
    searchFilters: any,
}

export interface BEIndexProcessedQueueJobPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedJobs: any,
    queueNames: any,
    jobStates: any,
    searchFilters: any,
    currentPage: any,
}

export interface BEIndexPendingQueueJobPagePropKeys {
    pageMeta: PageMeta,
    appSharedDataData: any,
    paginatedJobs: any,
    queueNames: any,
    jobStates: any,
    searchFilters: any,
    pendingQueueStats: any,
}

export interface BEGuestShowMeetingPagePropKeys {
    meetingSharedDataData: any,
    bookingDataData: any,
}

export interface BECreateCustomerNewPasswordPagePropKeys {
    customerSharedDataData: any,
    token: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BEShowCustomerPasswordResetPagePropKeys {
    customerSharedDataData: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BEShowCustomerLoginPagePropKeys {
    customerSharedDataData: any,
    googleSocialLoginEnabled: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
}

export interface BEIndexCompanyPagePropKeys {
    pageMeta: PageMeta,
    customerSharedDataData: any,
    companiesData: any,
}

export interface BEShowMeetingPagePropKeys {
    pageMeta: PageMeta,
    customerSharedDataData: any,
    meetingData: any,
    attendanceId: any,
}

export interface BEIndexMeetingPagePropKeys {
    pageMeta: PageMeta,
    customerSharedDataData: any,
    paginatedMeetingsData: any,
    companyData: any,
}

export interface CalendarDayType {
    date: string,
    isAvailable: boolean,
    isVisible: boolean,
    dayOfMonthNumber: number,
}

export interface CalendarWeekType {
    days: CalendarDayType[],
}

export interface CalendarMonthType {
    year: string,
    monthName: string,
    monthTextToken: TextTokenEnum,
    weeks: CalendarWeekType[],
}

export const MeetingLocationPerSchedulingStrategyList = [
    {
        schedulingStrategy: SchedulingStrategyEnum.SingleHostSingleAttendee,
        availableMeetingLocationTypes: [
            MeetingLocationTypeEnum.GoogleMeet,
            MeetingLocationTypeEnum.Zoom,
            MeetingLocationTypeEnum.Phone,
            MeetingLocationTypeEnum.InPersonHostDefined,
            MeetingLocationTypeEnum.InPersonAttendeeDefined,
        ],
    },
    {
        schedulingStrategy: SchedulingStrategyEnum.SingleHostMultipleAttendee,
        availableMeetingLocationTypes: [
            MeetingLocationTypeEnum.GoogleMeet,
            MeetingLocationTypeEnum.Zoom,
        ],
    },
]

export interface CustomFieldResponseDTO {
    customFieldId: number,
    response: string|number|boolean|null|string[],
}

export interface CustomFieldSettingsMultipleCheckboxType {
    version: 'v1',
    data: {
        multipleCheckboxOptions: string[],
    },
}

export interface CustomFieldSettingsTextType {
    version: 'v1',
    data: {
        textType: CustomFieldTextTypeEnum,
        textPlaceholderText: string|null,
        textMinLength: number,
        textMaxLength: number,
    },
}

export interface CustomFieldSettingsSingleCheckboxType {
    version: 'v1',
    data: {
        singleCheckboxLabel: string,
    },
}

export interface CustomFieldSettingsRadioSelectType {
    version: 'v1',
    data: {
        radioSelectType: CustomFieldRadioSelectTypeEnum,
        radioSelectOptions: string[],
    },
}

export interface CustomFieldSettingsNumberType {
    version: 'v1',
    data: {
        numberType: CustomFieldNumberTypeEnum,
        numberDecimalPlaces: number,
        numberMinValue: number,
        numberMaxValue: number,
        numberStepValue: string,
    },
}

export interface CustomFieldResponseDataRadioSelectType {
    version: 'v1',
    response: string,
}

export interface CustomFieldResponseDataTextType {
    version: 'v1',
    response: string,
}

export interface CustomFieldResponseDataNumberType {
    version: 'v1',
    response: number,
}

export interface CustomFieldResponseDataMultipleCheckboxType {
    version: 'v1',
    response: string[],
}

export interface CustomFieldResponseDataSingleCheckboxType {
    version: 'v1',
    response: boolean,
}

export const RAW_RESPONSE_CONTENT_KEY = 'response'
export const RAW_RESPONSE_CUSTOM_FIELD_ID_KEY = 'customFieldId'

export interface MeetingSearchFiltersType {
    page: number,
    perPage: number,
    search: string|null,
    serviceId: string|null,
    companyUserId: string|null,
    meetingState: string|null,
    dateType: MeetingSearchFiltersDateTypeEnum,
    meetingStartAtInAvailabilityTimeZone: string|null,
    meetingEndAtInAvailabilityTimeZone: string|null,
    hasFiltersApplied: boolean,
}

export interface MeetingStatsType {
    meetingTodayCount: number,
    meetingThisWeekCount: number,
    meetingThisMonthCount: number,
}

export const MAXIMUM_NUMBER_OF_SEATS_PER_MEETING = 50

export interface MeetingLocationType {
    id: string,
    type: MeetingLocationTypeEnum,
    label: string,
    localizationTextToken: TextTokenEnum|null,
}

export interface RecurringMeetingSearchFiltersType {
    page: number,
    perPage: number,
    search: string,
}

export interface IntegrationProviderDataType {
    key: IntegrationProviderEnum,
    label: string,
    thumbUrl: string,
    redirectUrl: string,
}

export interface OutlookCalendarSettingsData {
    version: 'v1',
    data: {
        shouldCheckExternalCalendarForConflicts: boolean,
    },
}

export interface GoogleCalendarSettingsData {
    version: 'v1',
    data: {
        shouldCheckExternalCalendarForConflicts: boolean,
    },
}

export interface UserProfilePictureFile {
    normalizedPathOrUrl: string,
    url: string,
    filename: string,
    extension: FileExtensionEnum,
    verticalPosition: ImageVerticalPositionEnum,
    horizontalPosition: ImageHorizontalPositionEnum,
    attributionText: string | null,
    attributionLink: string | null,
}

export const UserProfilePictureFileData = {
    allowedMimeTypes: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFileSizeInBytes: 1048576,
}

export interface PlanFeatureDisplayType {
    title: string,
    enabled: boolean,
}

export interface AvailabilityResultDateType {
    dateInAvailabilityTimeZoneForScheduling: string,
    dateInSelectedTimeZoneForDisplay: string,
    availabilityResultTimeSlots: AvailabilityResultTimeSlotType[],
}

export interface DateSpecificHoursType {
    id: string,
    startDate: string,
    endDate: string,
    timeRanges: TimeRangeType[],
}

export interface TimeRangeType {
    id: string,
    start: string,
    end: string,
}

export interface AvailabilityResultTimeSlotType {
    timeSlotInAvailabilityTimeZoneForScheduling: TimeRangeType,
    timeSlotInSelectedTimeZoneForDisplay: TimeRangeType,
    numberOfAvailableSeats: number,
}

export interface WeeklyHoursType {
    id: string,
    dayOfWeek: DayOfWeekEnum,
    timeRanges: TimeRangeType[],
}

export interface AutomationSearchFiltersType {
    page: number,
    perPage: number,
    search: string,
}

export interface AutomationTriggerDataXMinutesBeforeMeetingStartsType {
    version: 'v1',
    data: {
        timeAmount: TimeAmountType,
        serviceIds: string[],
        triggerForAllServices: boolean,
    },
}

export interface AutomationActionDataSendAttendeeMeetingReminderEmailType {
    version: 'v1',
    data: {},
}

export interface AutomationActionDataSendHostMeetingReminderEmailType {
    version: 'v1',
    data: {},
}

export interface CustomerPaymentMethodRawData {
    id: number,
    type: PaymentMethodTypeEnum,
    cardPaymentMethodData: CardPaymentMethodData | null,
    payPalPaymentMethodData: PayPalPaymentMethodData | null,
}

export interface CustomerProfilePictureFile {
    normalizedPathOrUrl: string,
    url: string,
    filename: string,
    extension: FileExtensionEnum,
    verticalPosition: ImageVerticalPositionEnum,
    horizontalPosition: ImageHorizontalPositionEnum,
    attributionText: string | null,
    attributionLink: string | null,
}

export const CustomerProfilePictureFileData = {
    allowedMimeTypes: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFileSizeInBytes: 1048576,
}

export interface EmbedButtonSettingsType {
    backgroundColor: string,
    textColor: string,
    textContent: string,
    fontWeight: number,
    fontSize: number,
    borderRadius: number,
    showIcon: boolean,
    destinationUrl: string,
}

export interface BookingFormThemeType {
    mainBackgroundColor: string,
    mainBackgroundShade: string,
    mainTextColor: string,
    mainTextShade: string,
    showCompanyDisplayName: boolean,
    showCompanyLogo: boolean,
    showCompanyCover: boolean,
    coverImagePosition: CoverImagePositionEnum,
}

export interface CompanyCoverFile {
    normalizedPathOrUrl: string,
    url: string,
    filename: string,
    extension: FileExtensionEnum,
    verticalPosition: ImageVerticalPositionEnum,
    horizontalPosition: ImageHorizontalPositionEnum,
    attributionText: string | null,
    attributionLink: string | null,
}

export const CompanyCoverFileData = {
    allowedMimeTypes: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFileSizeInBytes: 1048576,
}

export interface CompanyLogoFile {
    normalizedPathOrUrl: string,
    url: string,
    filename: string,
    extension: FileExtensionEnum,
    verticalPosition: ImageVerticalPositionEnum,
    horizontalPosition: ImageHorizontalPositionEnum,
    attributionText: string | null,
    attributionLink: string | null,
}

export const CompanyLogoFileData = {
    allowedMimeTypes: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFileSizeInBytes: 1048576,
}

export interface CookieConsentAuthEntityDataType {
    analyticsId: string,
    type: CookieConsentAuthEntityTypeEnum,
}

export interface GoogleAnalyticsCookieConsentScriptDataRawData {
    tag: string,
    isDebugModeEnabled: boolean,
}

export interface MicrosoftClarityCookieConsentScriptDataRawData {
    tag: string,
}

export interface PostHogCookieConsentScriptDataRawData {
    projectToken: string,
    apiHost: string,
    uiHost: string,
}

export interface CookieConsentRawRequestData {
    functional: boolean,
    analytics: boolean,
    marketing: boolean,
    expiresAtTimestamp: number,
}

export interface BusinessNameGeneratorStartPageContent {
    faqItems: {
        question: string;
        answer: string
    }[],
}

export interface GeneratedBusinessName {
    randomId: string,
    businessName: string,
    businessTagline: string,
}

export interface GeneratedService {
    name: string,
    description: string,
    durationInMinutes: number,
}

export interface AdminUserSearchFiltersType {
    page: number,
    perPage: number,
    search: string,
}

export interface QueueStatsDataType {
    jobsExecutedPerMinuteCount: number,
    completedJobsInTheLastHourCount: number,
    totalFailedJobsCount: number,
    failedJobsInTheLastDayCount: number,
    pendingJobsCount: number,
}

export interface QueueJobSearchFiltersType {
    page: number,
    perPage: number,
    search: string,
    queueName: string,
    jobState: string,
}

export interface PaginatedResultsType {
    currentPage: number,
    perPage: number,
    numberOfRecords: number,
    numberOfPages: number,
    beforeCurrent: number[],
    afterCurrent: number[],
    records: any[],
}

export const TIMEAMOUNT_AMOUNT_FIELD_KEY = 'amount'
export const TIMEAMOUNT_TYPE_FIELD_KEY = 'type'

export interface TimeAmountType {
    amount: number,
    type: TimeAmountTypeEnum,
}

export interface ArticleImageFile {
    normalizedPathOrUrl: string,
    url: string,
    filename: string,
    extension: FileExtensionEnum,
    verticalPosition: ImageVerticalPositionEnum,
    horizontalPosition: ImageHorizontalPositionEnum,
    attributionText: string | null,
    attributionLink: string | null,
}

export const ArticleImageFileData = {
    allowedMimeTypes: 'image/jpg, image/jpeg, image/png, image/webp',
    maxFileSizeInBytes: 1048576,
}

export interface PageMeta {
    pageTitle: string,
}

export interface FlashStatusType {
    type: FlashStatusTypeEnum,
    message: string,
}

export const MergeTagsByGroup = [
    {
        groupKey: MergeTagGroupEnum.SampleGroup,
        mergeTags: [
            MergeTagEnum.SampleTag,
        ],
    },
]

export type MergeTagsByGroupEntry = typeof MergeTagsByGroup[number]

export interface CompanyUserInviteData {
    id: any,
    companyUserEmail: any,
    acceptedAt: any,
    createdAt: any,
}

export interface CustomFieldData {
    id: any,
    type: any,
    internalName: any,
    title: any,
    description: any,
    settings: any,
    isRequired: any,
    isEnabled: any,
}

export interface CustomFieldResponseData {
    id: any,
    snapshotIsRequired: any,
    snapshotType: any,
    content: any,
}

export interface CustomFieldResponseDataData {
    customField: any,
    response: any,
}

export interface AttendanceRawData {
    id: any,
    reservationId: any,
    meetingId: any,
    state: any,
    cannotCancel: any,
}

export interface AttendanceDataRawData {
    attendanceRawData: any,
}

export interface DraftMeetingData {
    id: any,
    servicePriceId: any,
    selectedDateInSelectedTimeZoneForDisplay: any,
    selectedTimeSlotStartInSelectedTimeZoneForDisplay: any,
    selectedTimeSlotEndInSelectedTimeZoneForDisplay: any,
    selectedDateInAvailabilityTimeZoneForScheduling: any,
    selectedTimeSlotStartInAvailabilityTimeZoneForScheduling: any,
    selectedTimeSlotEndInAvailabilityTimeZoneForScheduling: any,
    selectedTimeZone: any,
    selectedMeetingLocationId: any,
    phoneNumber: any,
    phoneCountryCode: any,
    inPersonAttendeeDefinedMeetingLocationAddress: any,
    notes: any,
    customerName: any,
    customerEmail: any,
    customFieldResponsesData: any,
    numberOfRecurringMeetingsToSchedule: any,
    numberOfRequestedSeats: any,
    savePaymentMethod: any,
    selectedDateInSelectedTimeZoneForDisplayFormatted: any,
    selectedTimeSlotStartInSelectedTimeZoneForDisplayFormatted: any,
    selectedTimeSlotEndInSelectedTimeZoneForDisplayFormatted: any,
    selectedDateInAvailabilityTimeZoneForSchedulingFormatted: any,
    selectedTimeSlotStartInAvailabilityTimeZoneForSchedulingFormatted: any,
    selectedTimeSlotEndInAvailabilityTimeZoneForSchedulingFormatted: any,
}

export interface BookingDataRawDataApp {
    bookingRawData: any,
    meetingsDataRawData: any,
    nextMeetingDataRawData: any,
    serviceRawData: any,
    customFieldResponsesDataRawData: any,
    customerRawData: any,
    meetingRecurringDatesInAvailabilityTimezoneRawData: any,
    hostRawData: any,
    schedulingState: any,
    notes: any,
    cannotBeCanceled: any,
}

export interface BookingRawData {
    id: any,
    uniqueCode: any,
    snapshotGroupSchedulingSettings: any,
    snapshotRecurrenceSettings: any,
    numberOfScheduledMeetings: any,
    snapshotIsPaymentRequired: any,
}

export interface BookingPaymentData {
    id: any,
    state: any,
    amount: any,
    externalId: any,
    externalViewUrl: any,
    externalViewText: any,
    integrationProvider: any,
}

export interface ReservationRawData {
    id: any,
    companyCustomerId: any,
    selectedTimeZone: any,
    isPaymentRequired: any,
    numberOfSeatsReserved: any,
    notes: any,
    dateTimeFormatted: any,
    dateFormatted: any,
    startAtFormatted: any,
    endAtFormatted: any,
    cannotRefund: any,
    cannotReschedule: any,
}

export interface ReservationDataRawData {
    reservationRawData: any,
    bookingPaymentRawData: any,
    customerRawData: any,
    customFieldResponsesRawData: any,
}

export interface MeetingDataRawData {
    meetingRawData: any,
    attendancesDataRawData: any,
    reservationsDataRawData: any,
    serviceRawData: any,
    companyUserRawData: any,
    userRawData: any,
}

export interface MeetingData {
    id: any,
    bookingId: any,
    state: any,
    uniqueCode: any,
    duration: any,
    locationType: any,
    locationData: any,
    meetingLocationData: any,
    externalEventSyncState: any,
    snapshotIsPaymentRequired: any,
    snapshotSchedulingStrategy: any,
    snapshotMaximumNumberOfSeatsPerMeeting: any,
    recurringMeetingOrder: any,
    dateTimeFormatted: any,
    dateFormatted: any,
    startAtFormatted: any,
    endAtFormatted: any,
    dayOfWeekFormatted: any,
    isRecurring: any,
    isRefunded: any,
}

export interface MeetingsGroupedByDateRawData {
    rawDate: any,
    formattedDate: any,
    dayOfWeek: any,
    meetingsDataRawData: any,
}

export interface MeetingLocationData {
    id: any,
    type: any,
    label: any,
    localizationTextToken: any,
}

export interface MeetingRecurringDateData {
    uniqueCode: any,
    recurringMeetingOrder: any,
    recurringDate: any,
}

export interface RecurringDateData {
    localizedReadableDateTime: any,
    localizedReadableDate: any,
    localizedReadableTime: any,
    localizedDayOfWeekShort: any,
    localizedDayOfWeekLong: any,
}

export interface IntegrationData {
    id: any,
    name: any,
    provider: any,
    providerLabel: any,
    externalId: any,
    state: any,
    stateLabel: any,
    metadata: any,
}

export interface UserData {
    id: any,
    firstName: any,
    lastName: any,
    email: any,
    profilePicture: any,
    admin: any,
}

export interface PlanData {
    id: any,
    name: any,
    description: any,
    price: any,
    type: any,
    period: any,
    periodLabel: any,
    highlight: any,
    featuresDisplay: any,
    paddlePriceId: any,
}

export interface SubscriptionData {
    id: any,
    status: any,
    subscribedAt: any,
    canceledAt: any,
    gracePeriodEndsAt: any,
}

export interface CompanyUserAggregateData {
    companyUser: any,
    user: any,
    availability: any,
    services: any,
}

export interface CompanyUserData {
    id: any,
    companyId: any,
    userId: any,
    availabilityId: any,
    role: any,
    displayTimezone: any,
    isEnabled: any,
    isDeleted: any,
}

export interface DateTimeRangeData {
    start: any,
    end: any,
}

export interface WeeklyHoursData {
    id: any,
    dayOfWeek: any,
    timeRanges: any,
}

export interface DateSpecificHoursData {
    id: any,
    startDate: any,
    endDate: any,
    timeRanges: any,
}

export interface AvailabilityData {
    id: any,
    companyId: any,
    createdById: any,
    name: any,
    weeklyHours: any,
    dateSpecificHours: any,
    timeZone: any,
}

export interface TimeRangeData {
    id: any,
    start: any,
    end: any,
}

export interface AutomationRawData {
    id: any,
    companyId: any,
    name: any,
    state: any,
    actionType: any,
    actionData: any,
    triggerType: any,
    triggerData: any,
}

export interface ServiceAggregateData {
    service: any,
    servicePrices: any,
    customFields: any,
    integration: any,
    overlappingAvailability: any,
    enabledMeetingLocations: any,
}

export interface ServiceData {
    id: any,
    slug: any,
    schedulingStrategy: any,
    title: any,
    description: any,
    enabledMeetingLocationIds: any,
    durationInMinutes: any,
    intervalBetweenMeetings: any,
    maximumNumberOfSeatsPerMeeting: any,
    maximumBookingDaysInAdvance: any,
    minimumBookingHoursInAdvance: any,
    minimumCancelationHoursInAdvance: any,
    isPaymentRequired: any,
    isVisible: any,
    groupSchedulingSettings: any,
    recurrenceSettings: any,
    isEnabled: any,
}

export interface ServicePriceData {
    id: any,
    serviceId: any,
    price: any,
}

export interface RecurrenceSettingsData {
    frequencyType: any,
    maximumNumberOfRecurringMeetings: any,
    skipDatesWithNoAvailability: any,
    allowCustomNumberOfRecurringMeetings: any,
}

export interface PayPalPaymentMethodData {
    emailAddress: any,
}

export interface CardPaymentMethodData {
    cardLast4: any,
    cardExpirationYear: any,
    cardExpirationMonth: any,
    cardBrand: any,
    cardCountry: any,
}

export interface CustomerData {
    id: any,
    firstName: any,
    lastName: any,
    email: any,
    profilePicture: any,
}

export interface CompanyCustomerData {
    id: any,
    companyId: any,
    customerId: any,
    createdAt: any,
}

export interface InPersonHostDefinedMeetingLocationData {
    id: any,
    address: any,
    googleMapsUrl: any,
}

export interface CompanyData {
    id: any,
    defaultAvailabilityId: any,
    slug: any,
    displayName: any,
    logoImage: any,
    coverImage: any,
    defaultBookingFormTheme: any,
    embedButtonSettings: any,
    inPersonHostDefinedMeetingLocations: any,
}

export interface CompanyCustomerAggregateData {
    customer: any,
    companyCustomer: any,
}

export interface OnboardingRawData {
    id: any,
    companyId: any,
    step: any,
    surveyBookingReason: any,
    surveyBookingReasonDescription: any,
    surveyPreDefinedAvailabilityType: any,
    surveyPreviousSchedulingTool: any,
    surveyWebsiteUrl: any,
    surveyIndustry: any,
    surveyNumberOfEmployees: any,
}

export interface AvailabilityResultDateData {
    dateInAvailabilityTimeZoneForScheduling: any,
    dateInSelectedTimeZoneForDisplay: any,
    availabilityResultTimeSlots: any,
}

export interface AvailabilityResultTimeSlotData {
    timeSlotInAvailabilityTimeZoneForScheduling: any,
    timeSlotInSelectedTimeZoneForDisplay: any,
    numberOfAvailableSeats: any,
}

export interface CookieConsentRecordRawData {
    id: any,
    functional: any,
    analytics: any,
    marketing: any,
    expiresAtTimestamp: any,
}

export interface CookieConsentScriptDataRawData {
    provider: any,
    data: any,
}

export interface BusinessNameGeneratorSessionRawData {
    id: any,
    step: any,
    userPrompt: any,
    generatedBusinessNames: any,
    generatedService: any,
    selectedBusinessNameId: any,
}

export interface BEShowBusinessNameGeneratorStepSuccessPagePropKeys {
    freeToolSharedDataRawData: any,
    companyRawData: any,
    firstServiceRawData: any,
    selectedBusinessName: any,
}

export interface BEShowBusinessNameGeneratorStepStartPagePropKeys {
    freeToolSharedDataRawData: any,
    startPageContent: any,
    turnstileEnabled: any,
    turnstileSiteKey: any,
    businessNameGeneratorSessionRawData: any,
}

export interface BEShowBusinessNameGeneratorStepResultsPagePropKeys {
    freeToolSharedDataRawData: any,
    businessNameGeneratorSessionRawData: any,
}

export interface BEShowBusinessNameGeneratorStepResultPreviewPagePropKeys {
    freeToolSharedDataRawData: any,
    generatedService: any,
    selectedBusinessName: any,
}

export interface BEShowBusinessNameGeneratorStepRegisterPagePropKeys {
    freeToolSharedDataRawData: any,
    businessNameGeneratorSessionRawData: any,
    googleSocialLoginEnabled: any,
    microsoftSocialLoginEnabled: any,
}

export interface ProcessedQueueJobData {
    id: any,
    pendingQueueJobId: any,
    jobKey: any,
    jobState: any,
    queueName: any,
    payload: any,
    tags: any,
    appRequestContext: any,
    errors: any,
    maxExecutionTime: any,
    maxReleases: any,
    releasesCounter: any,
    maxRetries: any,
    retriesCounter: any,
    executeAfterTimestamp: any,
    createdAt: any,
}

export interface PendingQueueJobData {
    id: any,
    jobKey: any,
    jobState: any,
    queueName: any,
    payload: any,
    tags: any,
    appRequestContext: any,
    maxExecutionTime: any,
    maxReleases: any,
    releasesCounter: any,
    maxRetries: any,
    retriesCounter: any,
    executeAfterTimestamp: any,
    createdAt: any,
}

export interface CMSCategoryRawData {
    title: any,
    description: any,
    slug: any,
    url: any,
    subcategories: any,
}

export interface CMSBreadcrumbRawData {
    title: any,
    url: any,
}

export interface CMSArticleRawData {
    title: any,
    slug: any,
    url: any,
    excerpt: any,
    htmlContent: any,
    isFeatured: any,
    cover: any,
    breadcrumbs: any,
    publishedAt: any,
    lastUpdatedAt: any,
}

export interface CMSArticleImageData {
    image: any,
    thumb: any,
    attributionText: any,
    attributionLink: any,
}

export interface CMSSubcategoryRawData {
    title: any,
    description: any,
    slug: any,
    url: any,
    articles: any,
}

export interface MeetingSharedDataRawData {
    appName: any,
    isFreePlan: any,
    company: any,
    openCookieSettingsElementId: any,
}

export interface FreeToolSharedDataRawData {
    appName: any,
    currentRoute: any,
    isAuthenticated: any,
    flashStatus: any,
    openCookieSettingsElementId: any,
}

export interface AppSharedDataRawData {
    appName: any,
    currentRoute: any,
    isImpersonating: any,
    authUser: any,
    authCompany: any,
    authCompanyUser: any,
    tawktoScriptUrl: any,
    tawktoUserName: any,
    tawktoUserEmail: any,
    tawktoUserDataHash: any,
    flashStatus: any,
    integrationsRequiringAttention: any,
}

export interface BookingFormSharedDataRawData {
    appName: any,
    isFreePlan: any,
    bookingFormCompany: any,
    authCustomer: any,
    googleSocialLoginEnabled: any,
    currentUrl: any,
    flashErrorMessage: any,
    currentLocale: any,
    openCookieSettingsElementId: any,
}

export interface CustomerSharedDataRawData {
    appName: any,
    authCustomer: any,
    currentRoute: any,
}

export interface LandingPageSharedDataRawData {
    appName: any,
    openCookieSettingsElementId: any,
}

export interface BlogSharedDataRawData {
    appName: any,
    openCookieSettingsElementId: any,
}

export interface HelpCenterSharedDataRawData {
    appName: any,
    openCookieSettingsElementId: any,
}

export interface BookingDataRawDataMeeting {
    booking: any,
    meetingsData: any,
    cannotBeCanceled: any,
}

export const ANALYTICS_CLEANUP_REQUESTED_VALUE = 1

export const TURNSTILE_SCRIPT_ELEMENT_ID = 'turnstile-script-element'

export const USER_PROMPT_MAX_LENGTH = 1000
